import React from 'react'
import styles from './styles.module.scss'
import smoothscroll from 'smoothscroll-polyfill'

const NotFound = () => {
  smoothscroll.polyfill()
  return (
    <div className={styles.wrapper}>
      <p>Ошибка 404!</p>
      <p>Страница не найдена.</p>
    </div>
  )
}

export default NotFound
